<template>
  <div class="login-container">
      <!-- 头部样式 -->
      <loginHeader :activeIndex="activeIndex" @upActiveIndex="upActiveIndex" />
      <!-- 登录  -->
      <login  v-show="activeIndex == 1"/>
      <!-- 下载 -->
      <downloadApp v-show="activeIndex == 2" />
    <div style="height:10%;text-align: center;">
      <span style="font-size: 13px;padding: 5px 0 10px;display: block;">京付公司版权所有©2023</span>
      <span style="display: block;font-size: 10px;">ICP备案 冀ICP备2022030859号-1  </span>
<!--      公网安备 44010602006299  增值电信业务许可证 B0-00000000-->
    </div>
  </div>
</template>

<script>
import loginHeader from  "@/views/login/components/loginHeader"; //头部 
import login from  "@/views/login/components/login"; //登录页 
import downloadApp from  "@/views/login/components/downloadApp"; //登录页 

export default {
  components: {
    loginHeader,
    login,
    downloadApp
  },
  name: "index",
  data() {
    return {
      activeIndex:"1",
    }
  },
  mounted() {
    // this.getInfo(); //初始化
    sessionStorage.setItem('title', "万德付平台");
   
  },
  methods: {
    upActiveIndex(key) {
      this.activeIndex = key;
    }
  }
}
</script>
<style scoped lang="scss">
.clearfloat:after{
  display:block;
  clear:both;
  content:"";
  visibility:hidden;
  height:0
}
.clearfloat{
  zoom:1
}

.login-container {
  height: 100%;
  position: relative;
  background-color: #F8F9FE;
}
</style>